// @core/api/endpoints/authn/introspect_token.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  IntrospectTokenRequest,
  IntrospectTokenResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Introspect OAuth2 token
 * Returns metadata about an OAuth2 token including its validity, scope, and associated claims. Used by resource servers to validate tokens and extract user information.
 */
export async function IntrospectToken(
  data: IntrospectTokenRequest,
  options?: RequestOptions
): Promise<IntrospectTokenResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/introspect`;
  const requestOptions = options;
  return client.post<IntrospectTokenResponse>(requestPath, data, requestOptions);
}
